function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.3 11.202c0-1.448 1.178-2.626 2.626-2.626h40.912c1.453 0 2.626 1.178 2.626 2.626v21.733c0 1.453-1.173 2.626-2.626 2.626H6.926c-1.448 0-2.626-1.17-2.626-2.624z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.088 17.56l-4.564.77-1.48-1.912 1.833-4.206.07-.053zM49.712 1.6l.844-.647c.844-.61 2.084-.497 2.57.064.722.946 1.448 1.892 2.175 2.838.19.23.253.56.227.92-.054.587-.37 1.24-.83 1.58l-.843.647z",
  fillRule: "evenodd",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.524 18.33l-1.11.188c-.787.1-1.155-.374-.82-1.07l.45-1.03zm.423-6.17L49.712 1.6l4.14 5.402-13.764 10.56z",
  className: "icon-primary",
  fillRule: "evenodd",
  fill: "#ecaec6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 0.8000003309804,
  stroke: "#002060",
  fill: "none"
}, React.createElement("path", {
  d: "M35.524 18.33l-1.11.188c-.787.1-1.155-.374-.82-1.07l.45-1.03"
}), React.createElement("path", {
  d: "M40.088 17.56l-4.564.77-1.48-1.912 1.833-4.206.07-.053M49.712 1.6l.844-.647c.844-.61 2.084-.497 2.57.064.722.946 1.448 1.892 2.175 2.838.19.23.253.56.227.92-.054.587-.37 1.24-.83 1.58l-.843.647"
}), React.createElement("path", {
  d: "M35.947 12.16L49.712 1.6l4.14 5.402-13.764 10.56z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 28v4h4v-4zm0-8v4h4v-4zm0-8v4h4v-4z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  strokeMiterlimit: 8,
  d: "M50.46 13.605c-.027 5.89.025 13.44 0 19.33 0 1.453-1.287 2.626-2.878 2.626H7.398c-1.585 0-2.877-1.17-2.877-2.624V11.202c0-1.448 1.294-2.626 2.88-2.626h28.07",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  strokeMiterlimit: 9,
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M23.41 30.49h18.168M23.41 22.49h18.168",
  strokeWidth: 0.80000001
}), React.createElement("path", {
  d: "M23.41 14.533h8.103",
  strokeWidth: 0.80000007
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.523 19.503h4.984v4.982h-4.984zM13.523 11.495h4.984v4.982h-4.984zM13.523 27.504h4.984v4.982h-4.984z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
});

var SvgMenuSurveymodel = function SvgMenuSurveymodel(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuSurveymodel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-surveymodel.9261b767.svg";
export { ForwardRef as ReactComponent };